import { Subject } from 'rxjs';

const subject = new Subject();

export const broadCastService = {
    broadCast: (type, data = null) => subject.next({ type: type, data:data}),
    clearReceiver: () => subject.next(),
    receiver: () => subject.asObservable(),
};
